import { createFileRoute } from '@tanstack/react-router'
import { AgenticEvalsPage } from 'pages/evaluations/agentic/AgenticEvalsPage'

import { evalsSearchSchema } from './-searchParams'

const RouteComponent = () => {
  const searchParams = Route.useSearch()
  return <AgenticEvalsPage searchParams={searchParams} />
}

export const Route = createFileRoute('/evaluations/agentic/')({
  component: RouteComponent,
  validateSearch: evalsSearchSchema,
  staticData: {
    title: 'Agentic Evals',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: false,
      hideSiteSelector: true,
    },
  },
})
